import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useEffect, useMemo, useState, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getUserInfo } from "../../redux/handlers/auth/getUserInfo.handler";
import { getAllMstDiscountType } from "../../redux/handlers/master/getAllMstDiscountType.handler";
import { getAllMstPaymentType } from "../../redux/handlers/master/getAllMstPaymentType.handler";
import { getAllMstPriceCategory } from "../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstVat } from "../../redux/handlers/master/getAllMstVat.handler";
import { getAllWarehouse } from "../../redux/handlers/master/getAllWarehouse.handler";
import { getFirstMstCompany } from "../../redux/handlers/master/getFirstMstCompany.handler";
import { isValidArray, mapMstToOptions } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMstBranch } from "../../redux/handlers/master/getAllMstBranch.handler";
import { genNewDoDocNumber } from "../../redux/slices/logic/genNewDoDocNumber.slice";
import { useGlobalDocModalContext } from "contexts/GlobalDocModalContext";
import { mappingOptionNewItemDoCol } from "utils/HelperDoFunction";
import { getAllMstNewItemDoCol } from "../../redux/slices/master/getAllMstNewItemDoCol.slice";
export var useInitDo = function(param) {
    var doID = param.doID, formdata = param.formdata, setFormdata = param.setFormdata;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalDocModalContext = useGlobalDocModalContext(), modalNotiDocAlert = _useGlobalDocModalContext.modalNotiDocAlert, setModalNotiDocAlert = _useGlobalDocModalContext.setModalNotiDocAlert;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isLoading = _useGlobalLoaderContext.isLoading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    // Reducers
    var reducers = {
        paymentType: useAppSelector(function(state) {
            return state.getAllMstPaymentTypeReducer;
        }),
        priceCategory: useAppSelector(function(state) {
            return state.getAllMstPriceCategoryReducer;
        }),
        discountType: useAppSelector(function(state) {
            return state.getAllMstDiscountTypeReducer;
        }),
        vat: useAppSelector(function(state) {
            return state.getAllMstVatReducer;
        }),
        warehouse: useAppSelector(function(state) {
            return state.getAllWarehouseReducer;
        }),
        userInfo: useAppSelector(function(state) {
            return state.getUserInfoReducer;
        }),
        company: useAppSelector(function(state) {
            return state.getFirstMstCompanyReducer;
        }),
        genNewDocNumber: useAppSelector(function(state) {
            return state.genNewDoDocNumberReducer;
        }),
        doItemCol: useAppSelector(function(state) {
            return state.getAllMstNewItemDoColReducer;
        }),
        branch: useAppSelector(function(state) {
            return state.getAllMstBranchReducer;
        })
    };
    // Local state
    var _useState = _sliced_to_array(useState(null), 2), userInfo = _useState[0], setUserInfo = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), companyInfo = _useState1[0], setCompanyInfo = _useState1[1];
    // Derived options using useMemo for performance
    var options = useMemo(function() {
        var _reducers_paymentType_data, _reducers_priceCategory_data, _reducers_discountType_data, _reducers_vat_data, _reducers_warehouse_data, _reducers_doItemCol_data, _reducers_branch_data, _reducers_paymentType_data1, _reducers_priceCategory_data1, _reducers_discountType_data1, _reducers_vat_data_data, _reducers_vat_data1, _reducers_warehouse_data1, _reducers_doItemCol_data1, _reducers_branch_data1;
        var optionsInit = {
            paymentType: [],
            priceCategory: [],
            discountType: [],
            vat: [],
            warehouse: [],
            doItemCol: [],
            branch: []
        };
        var isReady = isValidArray((_reducers_paymentType_data = reducers.paymentType.data) === null || _reducers_paymentType_data === void 0 ? void 0 : _reducers_paymentType_data.data) && isValidArray((_reducers_priceCategory_data = reducers.priceCategory.data) === null || _reducers_priceCategory_data === void 0 ? void 0 : _reducers_priceCategory_data.data) && isValidArray((_reducers_discountType_data = reducers.discountType.data) === null || _reducers_discountType_data === void 0 ? void 0 : _reducers_discountType_data.data) && isValidArray((_reducers_vat_data = reducers.vat.data) === null || _reducers_vat_data === void 0 ? void 0 : _reducers_vat_data.data) && isValidArray((_reducers_warehouse_data = reducers.warehouse.data) === null || _reducers_warehouse_data === void 0 ? void 0 : _reducers_warehouse_data.data) && isValidArray((_reducers_doItemCol_data = reducers.doItemCol.data) === null || _reducers_doItemCol_data === void 0 ? void 0 : _reducers_doItemCol_data.data) && isValidArray((_reducers_branch_data = reducers.branch.data) === null || _reducers_branch_data === void 0 ? void 0 : _reducers_branch_data.data);
        if (!isReady) return optionsInit;
        return {
            paymentType: mapMstToOptions(((_reducers_paymentType_data1 = reducers.paymentType.data) === null || _reducers_paymentType_data1 === void 0 ? void 0 : _reducers_paymentType_data1.data) || []),
            priceCategory: mapMstToOptions(((_reducers_priceCategory_data1 = reducers.priceCategory.data) === null || _reducers_priceCategory_data1 === void 0 ? void 0 : _reducers_priceCategory_data1.data) || []),
            discountType: mapMstToOptions(((_reducers_discountType_data1 = reducers.discountType.data) === null || _reducers_discountType_data1 === void 0 ? void 0 : _reducers_discountType_data1.data) || []),
            vat: (_reducers_vat_data1 = reducers.vat.data) === null || _reducers_vat_data1 === void 0 ? void 0 : (_reducers_vat_data_data = _reducers_vat_data1.data) === null || _reducers_vat_data_data === void 0 ? void 0 : _reducers_vat_data_data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }),
            warehouse: mapMstToOptions(((_reducers_warehouse_data1 = reducers.warehouse.data) === null || _reducers_warehouse_data1 === void 0 ? void 0 : _reducers_warehouse_data1.data) || []),
            doItemCol: mappingOptionNewItemDoCol(((_reducers_doItemCol_data1 = reducers.doItemCol.data) === null || _reducers_doItemCol_data1 === void 0 ? void 0 : _reducers_doItemCol_data1.data) || []),
            branch: mapMstToOptions(((_reducers_branch_data1 = reducers.branch.data) === null || _reducers_branch_data1 === void 0 ? void 0 : _reducers_branch_data1.data) || [])
        };
    }, [
        reducers.paymentType.data,
        reducers.priceCategory.data,
        reducers.discountType.data,
        reducers.vat.data,
        reducers.warehouse.data,
        reducers.doItemCol.data,
        reducers.branch.data
    ]);
    var isInitDoLoading = useMemo(function() {
        return reducers.paymentType.isFetching || reducers.priceCategory.isFetching || reducers.discountType.isFetching || reducers.vat.isFetching || reducers.userInfo.isFetching || reducers.company.isFetching || reducers.genNewDocNumber.isFetching || reducers.doItemCol.isFetching || reducers.warehouse.isFetching || reducers.branch.isFetching;
    }, [
        reducers.paymentType.isFetching,
        reducers.priceCategory.isFetching,
        reducers.discountType.isFetching,
        reducers.vat.isFetching,
        reducers.userInfo.isFetching,
        reducers.company.isFetching,
        reducers.genNewDocNumber.isFetching,
        reducers.doItemCol.isFetching,
        reducers.warehouse.isFetching,
        reducers.branch.isFetching
    ]);
    // Load master data
    var loadMstData = useCallback(function() {
        dispatch(getAllMstPaymentType());
        dispatch(getAllMstPriceCategory());
        dispatch(getAllMstDiscountType());
        dispatch(getAllMstVat());
        dispatch(getAllWarehouse());
        dispatch(getFirstMstCompany());
        dispatch(getAllMstNewItemDoCol());
        dispatch(getAllMstBranch());
    }, []);
    // Load resources
    var loadResources = useCallback(function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (!doID) {
            dispatch(genNewDoDocNumber({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        doID
    ]);
    // Handle incoming data
    useEffect(function() {
        if (reducers.userInfo.data && reducers.userInfo.data !== userInfo) {
            setUserInfo(reducers.userInfo.data.data);
        }
        if (reducers.company.data && reducers.company.data !== companyInfo) {
            setCompanyInfo(reducers.company.data.data);
        }
        if (reducers.genNewDocNumber.data && !doID && reducers.genNewDocNumber.data.data !== formdata.doc_number) {
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    doc_number: reducers.genNewDocNumber.data.data
                });
            });
            setModalNotiDocAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    extra: {
                        genDocNumber: reducers.genNewDocNumber.data.data,
                        createdDocNumber: prev.extra.createdDocNumber
                    }
                });
            });
        }
    }, [
        reducers.userInfo.data,
        reducers.company.data,
        reducers.genNewDocNumber.data,
        userInfo,
        companyInfo,
        formdata.doc_number,
        doID
    ]);
    // Auto-load
    useEffect(function() {
        loadMstData();
        loadResources();
    }, [
        loadMstData,
        loadResources
    ]);
    // useEffect(() => {
    //   setIsLoading(isInitDoLoading);
    // }, [isInitDoLoading]);
    return {
        isInitDoLoading: isInitDoLoading,
        options: options,
        userInfo: userInfo,
        companyInfo: companyInfo
    };
};
